// extracted by mini-css-extract-plugin
module.exports = {"dataContainer":"ReadonlyDataFields_dataContainer__1mWUz","dataLabel":"ReadonlyDataFields_dataLabel__14MJp","dataValue":"ReadonlyDataFields_dataValue__1_zPv"};